/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "complimentary_actions";

/**
 * Definitions for how a complimentary action should be triggered.
 * NOTE: defined here and not in complimentary_actions.proto to avoid circular imports.
 */
export interface TriggerArgs {
}

/** Invoke the action's callback via `shared.add_timer_callback` with this `dt`. */
export interface TriggerArgs_TimerCallback {
  dt: number;
}

/** Invoke the action's callback via a subscription to the specified channel. */
export interface TriggerArgs_ChannelCallback {
  channel: TriggerArgs_ChannelCallback_Channel;
}

/**
 * An enumeration of supported channels. Any channel can be added; the
 * ChannelTriggeredComplimentaryActionBase class just needs to be updated to be able to map from
 * this channel enum to the channel message type. The enum values must exactly match the channel
 * name.
 */
export enum TriggerArgs_ChannelCallback_Channel {
  INVALID = 0,
  VEHICLE_POSE = 1,
  GO_TO_WAYPOINT_STATUS_PB = 2,
  MISSION_ACTION_EVENT_PB = 3,
  USER_CAMERA_PHOTO_CAPTURE = 4,
  MOTION_PLANNER_STATUS = 5,
  UNRECOGNIZED = -1,
}

export function triggerArgs_ChannelCallback_ChannelFromJSON(object: any): TriggerArgs_ChannelCallback_Channel {
  switch (object) {
    case 0:
    case "INVALID":
      return TriggerArgs_ChannelCallback_Channel.INVALID;
    case 1:
    case "VEHICLE_POSE":
      return TriggerArgs_ChannelCallback_Channel.VEHICLE_POSE;
    case 2:
    case "GO_TO_WAYPOINT_STATUS_PB":
      return TriggerArgs_ChannelCallback_Channel.GO_TO_WAYPOINT_STATUS_PB;
    case 3:
    case "MISSION_ACTION_EVENT_PB":
      return TriggerArgs_ChannelCallback_Channel.MISSION_ACTION_EVENT_PB;
    case 4:
    case "USER_CAMERA_PHOTO_CAPTURE":
      return TriggerArgs_ChannelCallback_Channel.USER_CAMERA_PHOTO_CAPTURE;
    case 5:
    case "MOTION_PLANNER_STATUS":
      return TriggerArgs_ChannelCallback_Channel.MOTION_PLANNER_STATUS;
    case -1:
    case "UNRECOGNIZED":
    default:
      return TriggerArgs_ChannelCallback_Channel.UNRECOGNIZED;
  }
}

export function triggerArgs_ChannelCallback_ChannelToJSON(object: TriggerArgs_ChannelCallback_Channel): string {
  switch (object) {
    case TriggerArgs_ChannelCallback_Channel.INVALID:
      return "INVALID";
    case TriggerArgs_ChannelCallback_Channel.VEHICLE_POSE:
      return "VEHICLE_POSE";
    case TriggerArgs_ChannelCallback_Channel.GO_TO_WAYPOINT_STATUS_PB:
      return "GO_TO_WAYPOINT_STATUS_PB";
    case TriggerArgs_ChannelCallback_Channel.MISSION_ACTION_EVENT_PB:
      return "MISSION_ACTION_EVENT_PB";
    case TriggerArgs_ChannelCallback_Channel.USER_CAMERA_PHOTO_CAPTURE:
      return "USER_CAMERA_PHOTO_CAPTURE";
    case TriggerArgs_ChannelCallback_Channel.MOTION_PLANNER_STATUS:
      return "MOTION_PLANNER_STATUS";
    case TriggerArgs_ChannelCallback_Channel.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBaseTriggerArgs(): TriggerArgs {
  return {};
}

export const TriggerArgs = {
  encode(_: TriggerArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TriggerArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTriggerArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): TriggerArgs {
    return {};
  },

  toJSON(_: TriggerArgs): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<TriggerArgs>, I>>(base?: I): TriggerArgs {
    return TriggerArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TriggerArgs>, I>>(_: I): TriggerArgs {
    const message = createBaseTriggerArgs();
    return message;
  },
};

function createBaseTriggerArgs_TimerCallback(): TriggerArgs_TimerCallback {
  return { dt: 0 };
}

export const TriggerArgs_TimerCallback = {
  encode(message: TriggerArgs_TimerCallback, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.dt !== 0) {
      writer.uint32(13).float(message.dt);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TriggerArgs_TimerCallback {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTriggerArgs_TimerCallback();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 13) {
            break;
          }

          message.dt = reader.float();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TriggerArgs_TimerCallback {
    return { dt: isSet(object.dt) ? globalThis.Number(object.dt) : 0 };
  },

  toJSON(message: TriggerArgs_TimerCallback): unknown {
    const obj: any = {};
    if (message.dt !== 0) {
      obj.dt = message.dt;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TriggerArgs_TimerCallback>, I>>(base?: I): TriggerArgs_TimerCallback {
    return TriggerArgs_TimerCallback.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TriggerArgs_TimerCallback>, I>>(object: I): TriggerArgs_TimerCallback {
    const message = createBaseTriggerArgs_TimerCallback();
    message.dt = object.dt ?? 0;
    return message;
  },
};

function createBaseTriggerArgs_ChannelCallback(): TriggerArgs_ChannelCallback {
  return { channel: 0 };
}

export const TriggerArgs_ChannelCallback = {
  encode(message: TriggerArgs_ChannelCallback, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.channel !== 0) {
      writer.uint32(8).int32(message.channel);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TriggerArgs_ChannelCallback {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTriggerArgs_ChannelCallback();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.channel = reader.int32() as any;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TriggerArgs_ChannelCallback {
    return { channel: isSet(object.channel) ? triggerArgs_ChannelCallback_ChannelFromJSON(object.channel) : 0 };
  },

  toJSON(message: TriggerArgs_ChannelCallback): unknown {
    const obj: any = {};
    if (message.channel !== 0) {
      obj.channel = triggerArgs_ChannelCallback_ChannelToJSON(message.channel);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TriggerArgs_ChannelCallback>, I>>(base?: I): TriggerArgs_ChannelCallback {
    return TriggerArgs_ChannelCallback.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TriggerArgs_ChannelCallback>, I>>(object: I): TriggerArgs_ChannelCallback {
    const message = createBaseTriggerArgs_ChannelCallback();
    message.channel = object.channel ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
